import React from "react";

function SnapPill({ variant, children }) {
  return <span className={`snap-pill ${variant}`}>{children}</span>;
}

// Complaints snap-row: total + CS/Public/IE source breakup, shared between
// the home Operations snapshot and the individual Location screen so the two
// never drift apart.
function ComplaintsSnapRow({ data, loading, onClick }) {
  const { total = 0, customerSupport = 0, public: pub = 0, independentEngineer = 0 } = data || {};
  const compSources = [
    { label: "CS", value: customerSupport, color: "#305878" },
    { label: "Public", value: pub, color: "#3d7a50" },
    { label: "IE", value: independentEngineer, color: "#5a3878" },
  ];
  const sourceTotal = compSources.reduce((s, c) => s + c.value, 0) || 1;

  return (
    <div className="snap-row" data-cy="snap-row-complaints" onClick={onClick} style={onClick ? { cursor: "pointer" } : undefined}>
      <div className="snap-icon">
        <svg viewBox="0 0 24 24">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </div>
      <div className="snap-body">
        <div className="snap-name">Complaints — <strong>{loading ? "—" : total}</strong></div>
        <div className="snap-pills">
          <SnapPill variant="neutral">{loading ? "—" : total} total</SnapPill>
          {!loading && customerSupport > 0 && <SnapPill variant="info">{customerSupport} CS</SnapPill>}
          {!loading && pub > 0 && <SnapPill variant="ok">{pub} public</SnapPill>}
          {!loading && independentEngineer > 0 && <SnapPill variant="neutral">{independentEngineer} IE</SnapPill>}
        </div>
        {!loading && total > 0 && (
          <div style={{ display: "flex", height: "3px", marginTop: "8px", gap: "1px" }}>
            {compSources.filter(s => s.value > 0).map((src) => (
              <div
                key={src.label}
                style={{ flex: src.value / sourceTotal, background: src.color, height: "100%" }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ComplaintsSnapRow;
